import { Controller } from '@hotwired/stimulus'
import { formatDistanceToNowStrict, parseISO } from 'date-fns'
import { fr } from 'date-fns/locale'

export default class extends Controller {
  static values = { date: String }

  connect() {
    this.element.innerText = formatDistanceToNowStrict(parseISO(this.dateValue), { locale: fr })
  }
}
